 export class mdlSelectedAddCovers{
    public DAB: number;
    public PAB: number;
    public BAHRAIN: number;
    public Geographical_Inc_Bahrain: number;
    public Geographical_EJL: number;
    public VEHICLE_REP:number;
    public ZERO_DEP:number;
    public DAB_VAT: number;
    public PAB_VAT: number;
    public BAHRAIN_VAT: number;
    public Geographical_Inc_Bahrain_VAT: number;
    public Geographical_EJL_VAT: number;
    public VEHICLE_REP_VAT:number;
    public ZERO_DEP_VAT:number;
 }


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlSelectedAddCovers.ts